import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../../../component/BreadCrumb';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import { actionSearch, handleSemesterNm } from '../../../module/body/subject/SubjectSearchModule';
import { IconButton, Tooltip } from '@material-ui/core';
import PdfViewModal from '../../modal/PdfViewModal';
import SubjectDetailModal from '../../modal/SubjectDetailModal';
import InputModal from '../../../component/ModalRef';
import SelectionBox from '../../../component/SelectionBox';
import InputBox from '../../../component/InputBox';
import TimePickerBox from '../../../component/TimePickerBox';
import CautionBox from '../../../component/CautionBox';
import { modalType } from '../../../util/ModalUtil';
import SubjectIcon from '../../../component/icon/SubjectIcon';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import GridTimeBox from '../../../component/GridTimeBox';
import PathUtil from '../../../util/PathUtil';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import SemesterUtil from '../../../util/SemesterUtil';
import { VIEW_SUBJECT_SEARCH_BODY } from './../../../constant/ViewConstant';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import { actionInit } from '../../../module/body/system/SystemSubjectCodeModule';
import TableBox from '../../../component/TableBox';
import { defaultGridData, handleControl, initGrid } from '../../../module/component/TableBoxModule';
import NullCheckUtil from '../../../util/NullCheckUtil';
import PopupRef from '../../../component/PopupRef';
import { OpenDetailIcon } from '../../../component/icon/GridIcons';
import ExcelDownloadButtonBox from '../../../component/buttons/ExcelDownloadButtonBox';
import { actionExcelDownload } from '../../../module/body/semester/SemesterSubjectModule';

const ConditionArea = ({ modalRef, popupRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const dispatch = useDispatch();

    const [semesterId, setSemesterId] = useState('');
    const [subjectTypeCd, setSubjectTypeCd] = useState();
    const [subjectNm, setSubjectNm] = useState();
    const [lessonUniversityCd, setLessonUniversityCd] = useState();
    const [lessonTypeCd, setLessonTypeCd] = useState();
    const [weekdayCd, setWeekdayCd] = useState();
    const [bgnTime, setBgnTime] = useState();
    const [endTime, setEndTime] = useState();

    const [params, setParams] = useState({});
    const { gridData } = useSelector((state) => state.tableBoxState);

    const { semesterNm } = useSelector((state) => state.subjectSearchState);

    const isValidParams = (params) => {
        if (Number(params.bgnTime) > Number(params.endTime)) {
            popupRef.current.openInfo('조회조건 시작시간은 종료시간보다 작아야합니다.');
            return false;
        }

        return true;
    };

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        // 최초 로딩시 URL 정보를 통해 설정
        queryData.semesterId == undefined
            ? setSemesterId(SessionStorageUtil.getCurrentSemesterId())
            : setSemesterId(queryData.semesterId);
        queryData.subjectTypeCd && setSubjectTypeCd(queryData.subjectTypeCd);
        queryData.subjectNm && setSubjectNm(queryData.subjectNm);
        queryData.lessonUniversityCd && setLessonUniversityCd(queryData.lessonUniversityCd);
        queryData.lessonTypeCd && setLessonTypeCd(queryData.lessonTypeCd);
        queryData.weekdayCd && setWeekdayCd(queryData.weekdayCd);
        queryData.bgnTime && setBgnTime(queryData.bgnTime);
        queryData.endTime && setEndTime(queryData.endTime);

        dispatch(
            handleSemesterNm(
                SemesterUtil.convertSemesterNm(
                    queryData.semesterId == undefined
                        ? SessionStorageUtil.getCurrentSemesterId()
                        : queryData.semesterId,
                ),
            ),
        );
        onClickSearch({
            semesterId:
                queryData.semesterId == undefined ? SessionStorageUtil.getCurrentSemesterId() : queryData.semesterId,
            subjectTypeCd: queryData.subjectTypeCd,
            lessonUniversityCd: queryData.lessonUniversityCd,
            lessonTypeCd: queryData.lessonTypeCd,
            subjectNm: queryData.subjectNm,
            weekdayCd: NullCheckUtil.isNotNull(queryData.weekdayCd) ? queryData.weekdayCd : '',
            bgnTime: NullCheckUtil.isNotNull(queryData.bgnTime) ? queryData.bgnTime : '',
            endTime: NullCheckUtil.isNotNull(queryData.endTime) ? queryData.endTime : '',
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 10,
        });

        return () => {
            dispatch(actionInit());
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClickSearch({
            ...params,
            page,
            pageSize,
        });
    };

    const onClickSearch = (params) => {
        dispatch(handleSemesterNm(SemesterUtil.convertSemesterNm(params.semesterId)));
        setParams(params);
        if (isValidParams(params)) {
            dispatch(
                actionSearch({
                    params,
                    callback: (result) => {
                        if (result.totalCount == 0) {
                            popupRef.current.openAlert('조회된 결과가 없습니다.');
                        }
                    },
                }),
            );
        }
        PathUtil.pushState(location.pathname, params);
    };

    const onRowDoubleClick = (row, params) => {
        modalRef.current.open(
            <SubjectDetailModal
                type={modalType.DETAIL}
                searchParams={{
                    semesterId: row.semesterId,
                    lessonUniversityCd: row.lessonUniversityCd,
                    subjectId: row.subjectId,
                    classNo: row.classNo,
                    universitySubjectId: row.universitySubjectId,
                }}
                callback={() => {
                    onClickSearch(params);
                }}
                modalRef={modalRef}
            />,
            'large',
        );
    };

    const handlePdfView = (row) => {
        if (NullCheckUtil.isEmpty(row.lessonPlanFileUid)) {
            popupRef.current.openAlert('강의계획서가 등록되어 있지 않습니다.');
        } else {
            modalRef.current.open(
                <PdfViewModal fileUid={row.lessonPlanFileUid} fileSize={row.lessonPlanFileSize} modalRef={modalRef} />,
                'large',
            );
        }
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({
                semesterId,
                subjectTypeCd,
                lessonUniversityCd,
                lessonTypeCd,
                subjectNm,
                weekdayCd,
                bgnTime,
                endTime,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const handleDownload = () => {
        dispatch(actionExcelDownload({ params: params }));
    };

    const columns = useMemo(
        () => [
            {
                field: 'lessonUniversityCd',
                headerName: '개설대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.MAIN_UNIVERSITY, params.row.lessonUniversityCd),
            },
            {
                field: 'subjectTypeCd',
                headerName: '과정구분',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.SUBJECT_TYPE, params.row.subjectTypeCd),
            },
            {
                field: 'subjectNm',
                headerName: '교과목',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 15,
            },
            { field: 'classNo', headerName: '분반', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            // {
            //     field: 'universitySubjectId',
            //     headerName: '교과목코드',
            //     headerAlign: 'center',
            //     align: 'center',
            //     tooltip: true,
            //     flex: 10,
            // },
            { field: 'profNm', headerName: '교강사', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            { field: 'creditCnt', headerName: '학점', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            {
                field: 'lessonTypeCd',
                headerName: '수업방식',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.LESSON_TYPE, params.row.lessonTypeCd),
            },
            {
                field: 'courseTimes',
                headerName: '강의시간',
                headerAlign: 'center',
                tooltip: true,
                flex: 24,
                renderCell: (params) => <GridTimeBox times={params.row.courseTimes} />,
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 12,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='상세'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenDetailIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title='강의계획서'>
                            <IconButton onClick={() => handlePdfView(item.row)}>
                                <SubjectIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <>
            <div className='con-form-wrap'>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='학기'
                                    value={semesterId}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                    onChange={(e) => setSemesterId(e.target.value)}
                                    useAll={false}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='개설대학'
                                    w140
                                    value={lessonUniversityCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                    onChange={(e) => setLessonUniversityCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='마이크로디그리 과정'
                                    value={subjectTypeCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SUBJECT_TYPE)}
                                    onChange={(e) => setSubjectTypeCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <InputBox
                                    title='교과목'
                                    value={subjectNm}
                                    onChange={(e) => setSubjectNm(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />

                                <SelectionBox
                                    title='수업방식'
                                    w140
                                    value={lessonTypeCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.LESSON_TYPE)}
                                    onChange={(e) => setLessonTypeCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='강의조회'
                                    onClick={(e) =>
                                        onClickSearch({
                                            semesterId,
                                            subjectTypeCd,
                                            lessonUniversityCd,
                                            lessonTypeCd,
                                            subjectNm,
                                            weekdayCd,
                                            bgnTime,
                                            endTime,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className='board-row'>
                        <div className='lec-check-box mt16'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='요일'
                                    w140
                                    value={weekdayCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.WEEKDAY)}
                                    onChange={(e) => setWeekdayCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <TimePickerBox
                                    title='시작시간'
                                    value={bgnTime}
                                    onChangeTimeString={(timeString) => setBgnTime(timeString)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <TimePickerBox
                                    title='종료시간'
                                    value={endTime}
                                    onChangeTimeString={(timeString) => setEndTime(timeString)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                        </div>
                        <CautionBox
                            title='수강신청 유의사항 확인'
                            checkedEnabled={false}
                            path='#none;'
                            semesterId={semesterId}
                            semesterNm={semesterNm}
                        />
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title'>
                    <h3 className='tb-tit-name'>강의 목록 {semesterNm && `(${semesterNm})`}</h3>
                    <div className='btn-group'>
                        <ExcelDownloadButtonBox onClick={(e) => handleDownload()} />
                    </div>
                </div>
            </div>
            <div className=''>
                <TableBox defaultWide={false} defaultPageSize={10} />
            </div>
        </>
    );
};

const SubjectSearchView = () => {
    const modalRef = useRef(null);
    const popupRef = useRef(null);
    return (
        <div className='body-view'>
            <section className='container'>
                <div className='container-inner'>
                    <div className='con-title-wrap conbg01'>
                        {/* <h2 className='con-title'>강의조회</h2> */}
                        <h2 className='con-title'>{VIEW_SUBJECT_SEARCH_BODY.title}</h2>
                        <p className='con-title-p'>{VIEW_SUBJECT_SEARCH_BODY.subTitle}</p>
                    </div>
                    <div className='sub-nav-wrap'>
                        <BreadCrumb />
                    </div>
                    <ConditionArea modalRef={modalRef} popupRef={popupRef} />
                </div>
            </section>
            <InputModal ref={modalRef} />
            <PopupRef ref={popupRef} />
        </div>
    );
};

export default SubjectSearchView;
